'use client';

import {
    useConsumerSubscriptionGwGPlan,
    useConsumerSubscriptionGwGPlusPersonalPlan,
} from '@udemy-v2/subscription-graphql';

/**
 * Mirrors v1's useIsGwgAvailable: true if either GWG plan context has resolved
 * to a real subscription (has an id or the visitor is a subscriber to it).
 */
export function useIsGwgAvailable(): boolean | undefined {
    const gwgPlan = useConsumerSubscriptionGwGPlan();
    const gwgPlusPPPlan = useConsumerSubscriptionGwGPlusPersonalPlan();
    const plans = [gwgPlan, gwgPlusPPPlan];

    const isEligible = plans.some(
        (plan) => !!(plan && !plan.isLoading && ('id' in plan || plan.isSubscriber)),
    );
    if (isEligible) return true;

    const isStillLoading = plans.some((plan) => plan?.isLoading);
    return isStillLoading ? undefined : false;
}
